import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SearchBar from "../../../components/SearchBar";
import { MenuTextField } from "../../../components/CustomTextField";
import createZoneFilterList from "../../../functions/Zoning.js";

const typeOptions = [
  { label: "All", value: "All" },
  { label: "League", value: "League" },
  { label: "Event", value: "Event" },
];
const statusOptions = [
  { label: "All", value: "All" },
  { label: "Approved", value: "approved" },
  { label: "Active", value: "active" },
  { label: "Playoffs", value: "playoffs" },
  { label: "Pending", value: "pending" },
  { label: "Expired", value: "expired" },
];
const LeagueSearchBar = ({
  search,
  setSearch,
  user,
  filterByType,
  setFilterByType,
  sectionSelect,
  setSectionSelect,
  localeSelect,
  setLocaleSelect,
  areaSelect,
  setAreaSelect,
  zoneList,
  statusSelect,
  setStatusSelect,
}) => {
  const [sectionList, setSectionList] = useState([]);
  const [localeList, setLocaleList] = useState([]);
  const [areaList, setAreaList] = useState([]);

  useEffect(() => {
    createZoneFilterList(
      zoneList,
      user.playLocation.sectionals,
      user.playLocation.locale,
      setSectionList,
      setLocaleList,
      setAreaList
    );
    // eslint-disable-next-line
  }, [user.playLocation.locale, user.playLocation.sectionals]);
  const handleFilterReset = () => {
    setSearch("");
    setSectionSelect(user.playLocation.sectionals);
    setLocaleSelect("All");
    setAreaSelect("All");
    setStatusSelect("All");
    setFilterByType("All");
    createZoneFilterList(
      zoneList,
      user.playLocation.sectionals,
      user.playLocation.locale,
      setSectionList,
      setLocaleList,
      setAreaList
    );
  };
  const handleSectionalChange = (e) => {
    let section = e.target.value;
    setSectionSelect(section);
    setLocaleSelect("All");
    setAreaSelect("All");
    if (section !== "All")
      createZoneFilterList(
        zoneList,
        section,
        "",
        setSectionList,
        setLocaleList,
        setAreaList
      );
  };
  const handleLocaleChange = (e) => {
    let locale = e.target.value;
    setLocaleSelect(locale);
    setAreaSelect("All");
    if (locale !== "All")
      createZoneFilterList(
        zoneList,
        sectionSelect,
        locale,
        setSectionList,
        setLocaleList,
        setAreaList
      );
  };
  return (
    <SearchBar search={search} setSearch={setSearch}>
      <div className="searchBar5Fields">
        <MenuTextField
          state={statusSelect}
          setState={setStatusSelect}
          menuSelection={statusOptions}
        />
      </div>
      <div className="searchBar5Fields">
        <MenuTextField
          state={filterByType}
          setState={setFilterByType}
          menuSelection={typeOptions}
        />
      </div>
      <div className="searchBar5Fields">
        <MenuTextField
          state={sectionSelect}
          setState={setSectionSelect}
          menuSelection={sectionList}
          customFunction={handleSectionalChange}
        />
      </div>
      <div className="searchBar5Fields">
        <MenuTextField
          state={localeSelect}
          setState={setLocaleSelect}
          menuSelection={localeList}
          customFunction={handleLocaleChange}
          disabled={sectionSelect === "All"}
        />
      </div>
      <div className="searchBar5Fields">
        <MenuTextField
          state={areaSelect}
          setState={setAreaSelect}
          menuSelection={areaList}
          disabled={localeSelect === "All" || sectionSelect === "All"}
        />
      </div>
      <div className="filler" />
      <div className="searchBarClearField">
        <Button variant="text" onClick={handleFilterReset}>
          <Typography className="leagueSearchBarClearText">
            Clear All
          </Typography>
        </Button>
      </div>
    </SearchBar>
  );
};
export default LeagueSearchBar;
